import { render } from "./CardanoChart.vue?vue&type=template&id=2f0ec22a&ts=true"
import script from "./CardanoChart.vue?vue&type=script&lang=ts"
export * from "./CardanoChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__